export default "__VITE_ASSET__BlH5bp9$__"